<template>
  <v-app v-show="$auth.ready()">

    <v-dialog v-model="showNotificationsSetupDialog" persistent max-width="800">
      <v-card>
        <v-card-title class="text-h5">Notification Settings</v-card-title>
        <v-card-text>We would like to send you notifications about ongoing events and interesting updates from time to time. Tells us if you wish to receive mails from us to keep you up to date! You may always change your preferences in your user profile view.</v-card-text>
        <v-simple-table class="mx-5 mb-5">
          <template v-slot:default>
            <tbody>
            <tr><td>Receive General Notifications</td><td><v-switch v-model="$auth.user().receiveGeneralNotifications" /></td></tr>
            <tr><td>Receive Challenge Notifications</td><td><v-switch v-model="$auth.user().receiveChallengeNotifications" /></td></tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="updateNotificationSettings">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-app-bar v-if="!this.showEmbedded" app dense>
      <v-app-bar-nav-icon v-if="this.$vuetify.breakpoint.xsOnly" @click="drawer = true"></v-app-bar-nav-icon>
      <v-img class="mx-auto" min-width="100" max-width="100" src="@/assets/esail-logo.png"/>
      <v-toolbar-title v-if="this.$vuetify.breakpoint.smAndUp" class="pl-10">Live Sailing Web Hub</v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items>
      <div v-if="isMobile" style="width:160px;align-items:center;padding:12px" @click="switchContent('/weather-card')">
        <WeatherForecastWidget date="now"></WeatherForecastWidget>
      </div>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer app v-if="!this.showEmbedded" v-model="drawer" :mini-variant="mini" :permanent="this.$vuetify.breakpoint.smAndUp">

      <v-list-item class="px-2" @click="switchContent('/user-profile')">
        <v-list-item-avatar>
          <v-avatar class="pr-2" v-if="$auth.user()" color="teal">
            <span class="white--text">{{ this.getUserInitials(this.$auth.user()) }}</span>
          </v-avatar>
          <v-avatar class="pr-2" v-else color="grey"><v-icon large color="white">mdi-account</v-icon></v-avatar>
        </v-list-item-avatar>
        <v-list-item-title v-if="$auth.user()">{{ $auth.user().fullName ? $auth.user().fullName : $auth.user().username }}</v-list-item-title>
        <v-list-item-title v-else>Login</v-list-item-title>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item v-for="item in filteredMenuItems" :key="item.title" @click="switchContent(item.targetView)">
            <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>{{ item.title }}</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list-item>
        <v-list-item-icon v-if="mini" @click="mini = false"><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
      </v-list-item>

    </v-navigation-drawer>

    <v-main>
      <v-banner v-if="!this.showEmbedded && banner.show " color="yellow lighten-5" single-line>
        {{ banner.message.text }}
        <template v-slot:actions="{dismiss}">
          <v-btn text color="primary" @click="dismiss">Dismiss</v-btn>
        </template>
      </v-banner>
      <router-view></router-view>
    </v-main>

    <v-footer app padless></v-footer>

  </v-app>
</template>

<script>
import WeatherForecastWidget from "./components/WeatherForecastWidget";
import {eSailServerAuth, eSailServerPublic} from "@/plugins/axios";

export default {
  name: 'App',
  components: {
    WeatherForecastWidget
  },
  data: () => ({
    banner: {
      show: false,
      message: { text: "" },
      hash: null
    },
    showNotificationsSetupDialog: false,
    showEmbedded: false,
    drawer: false,
    mini: true,
    authLevel: 'ANONYMOUS',
    menuItems: [
      { title: 'Home', icon: 'mdi-home-analytics', targetView: '/home' },
      { title: 'Weather Report', icon: 'mdi-weather-cloudy', mobileOnly: true, targetView: '/weather-card' },
      { title: 'History', icon: 'mdi-ballot', authLevel: 'USER', targetView: '/history' },
      { title: 'Online Users', icon: 'mdi-account-group', mobileOnly: true, targetView: '/online-users' },
      { title: 'Leaderboard', icon: 'mdi-trophy', mobileOnly: true, targetView: '/leaderboard' },
      { title: 'Statistics', icon: 'mdi-chart-bar', authLevel: 'ADMIN', mobileOnly: false, targetView: '/statistics' },
      { title: 'Administration', icon: 'mdi-cog', authLevel: 'ADMIN', targetView: '/administration' },
    ]
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    filteredMenuItems() {
      let res = []
      this.menuItems.forEach(it => {
        if (this.isAuthorized(it.authLevel) && (!it.mobileOnly || it.mobileOnly && this.isMobile)) {
          res.push(it)
        }
      })
      return res
    }
  },
  mounted() {
    //fetch embedded mode from query param, NOT: this.$route.query.embedded DOES NOT WORK IN NGINX - only in local dev mode
    const urlParams = new URLSearchParams(window.location.search);
    // this.showEmbedded = this.$route.query.embedded === "true"
    this.showEmbedded = urlParams.get('embedded') === "true"
    this.$auth.load()
      .then(() => {
        this.showNotificationsSetupDialog = !this.showEmbedded && (this.$auth.user().receiveGeneralNotifications === null || this.$auth.user().receiveGeneralNotifications === undefined)
        if (this.showNotificationsSetupDialog) {
          this.$auth.user().receiveGeneralNotifications = true
          this.$auth.user().receiveChallengeNotifications = true
        }
      });

    const md5 = require('md5');
    eSailServerPublic.get('info/environment/variables/info_banner')
        .then(response => {
          this.banner.message = response.data
          this.banner.show = this.banner.message.text.length > 0
          this.banner.hash = md5(this.banner.message.text);
        })
  },
  methods: {
    switchContent(targetView) {
      if (this.$route.path !== targetView) {
        this.$router.push(targetView);
      }
    },
    isAuthorized(authLevel) {
      this.authLevel = this.$auth.user() ? this.$auth.user().role : 'ANONYMOUS'
      switch (authLevel) {
          case undefined:
          case 'ANONYMOUS':
            return true
          case 'USER':
            return this.authLevel === 'USER' || this.authLevel === 'CONTENT_CREATOR' || this.authLevel === 'ADMIN' || this.authLevel === 'SUPER_ADMIN'
          case 'CONTENT_CREATOR':
            return this.authLevel === 'CONTENT_CREATOR' || this.authLevel === 'ADMIN' || this.authLevel === 'SUPER_ADMIN'
          case 'ADMIN':
            return this.authLevel === 'ADMIN' || this.authLevel === 'SUPER_ADMIN'
          case 'SUPER_ADMIN':
            return this.authLevel === 'SUPER_ADMIN'
          default:
            return false
      }
    },
    getUserInitials(user) {
      const names = user.fullName ? user.fullName.split(' ') : user.username.split(' ')
      let initials = names[0].substring(0, 1).toUpperCase()
      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase()
      }
      return initials
    },
    updateNotificationSettings() {
      eSailServerAuth.put('users/current/notifications', this.$auth.user(), { headers: { Authorization: `Bearer ` + this.$auth.token() }})
          .then(() => { this.showNotificationsSetupDialog = false })
    }
  }
};
</script>

<style scoped>

</style>